import { useQuery } from '@tanstack/react-query';
import { getGeoDefaults, type GeoDefaultsResponse } from '@/services/marketplaceSearchService';

/**
 * Fetches geo-based search defaults (currency, curricula, languages, price range).
 * Callers are responsible for deciding whether to apply defaults:
 *   - Apply only if no filter URL params are currently set (URL takes precedence).
 *
 * Pass the caller's accessToken when authenticated so a student's persisted
 * profile currency can override their physical location (ADR 067). The query
 * key is segmented by token so an anonymous result cached before login is
 * never served to an authenticated request afterward — without this, the
 * 10-minute staleTime would silently show the wrong currency for up to that
 * long right after a student logs in on the same page load.
 */
export function useGeoDefaults(accessToken?: string | null) {
  return useQuery<GeoDefaultsResponse>({
    queryKey: ['marketplace-geo-defaults', accessToken ?? 'anon'],
    queryFn: () => getGeoDefaults(accessToken),
    staleTime: 10 * 60 * 1000, // 10 minutes — geo defaults change rarely
  });
}
